import { projectDocuments, projectStatusMap } from "@/components/Project/index.ts";
import type { Project } from "@/queries/project.ts";
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import type { ReactNode } from "react";
import DocumentListItem from "./DocumentListItem.tsx";

type Props = {
    project: Project;
    open: boolean;
    onClose: () => void;
    onExited: () => void;
};

const ManageDocumentsDialog = ({ project, open, onClose, onExited }: Props): ReactNode => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionProps={{ onExited }}
            maxWidth="xs"
            fullWidth
            fullScreen={fullScreen}
        >
            <DialogTitle>Manage Documents</DialogTitle>
            <DialogContent>
                <Typography mb={1}>
                    {project.vendor.name} - {project.name}
                </Typography>
                <Chip label={projectStatusMap[project.status].label} sx={{ mb: 2 }} />

                <List>
                    {projectDocuments.map(({ key, label }) => (
                        <DocumentListItem
                            key={key}
                            label={label}
                            project={project}
                            documentKey={key}
                        />
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ManageDocumentsDialog;
